<template>
  <div class="container">
    <p>
      资源助手是一款帮助您在任何网站检索内容的时候能够发现馆藏资源和OA资源以及文献传递和按需单篇获取文献的链接渠道的软件。以下是提供常用浏览器的按照教程，只要按照教程安装即可。
    </p>
    <img src="../../assets/images/newhelp/help36.png" alt="" />
    <p>
      在安装完资源助手相关插件以后，在网站上检索资源时会出现红色全文获取的按钮，点击红色按钮，即可获取出现获取文章的链接，点击链接即可获取文献！
    </p>
    <img src="../../assets/images/newhelp/help37.png" alt="" />
  </div>
</template>
<script>
export default {
  name: "Page1",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.container {
  padding: 75px;
  p,
  img {
    margin-bottom: 15px;
    font-size: 18px;
    max-width: 100%;
  }
  .red {
    color: #fa0000;
  }
}
</style>
